import { MBText } from '@shared/components/MBText';
import { Colors } from '@shared/styles';
import { API } from '@shared/types/api';

interface MBSentBySMSProps {
  message: API.ChatMessageFragment;
}

/*
    Simple text indicating that the message has been sent by SMS
*/
export function MBSentBySMS({ message }: MBSentBySMSProps) {
  if (!message.urgent && !message.sentBySMS) {
    return null;
  }
  return (
    <MBText color={Colors.gray.normal} style={{ paddingTop: 2, fontSize: 10 }}>
      Sent by SMS
    </MBText>
  );
}
